class FostrFormValidation {

  constructor() {
    this.translations = {
      en: {
        password_blank: 'The password cannot be blank',
        password_lowercase: 'The password needs at least one lowercase letter',
        password_uppercase: 'The password needs at least one capital letter',
        password_number: 'The password needs at least one number',
        password_special: 'The password needs at least one special character',
        password_length: 'The password needs at least 8 characters',
        passwords_no_match: 'The passwords do not match',
        email_required: 'The email address is required',
        email_invalid: 'Please enter a valid email address',
        field_required: '{{ field }} is required',
        checkbox_required: 'This field is required',
        error_header: 'Please correct the following error'
      },
      it: {
        password_blank: 'La password non può essere vuota',
        password_lowercase: 'La password deve contenere almeno una lettera minuscola',
        password_uppercase: 'La password deve contenere almeno una lettera maiuscola',
        password_number: 'La password deve contenere almeno un numero',
        password_special: 'La password deve contenere almeno un carattere speciale',
        password_length: 'La password deve contenere almeno 8 caratteri',
        passwords_no_match: 'Le password non corrispondono',
        email_required: "L'indirizzo email è obbligatorio",
        email_invalid: 'Inserisci un indirizzo email valido',
        field_required: '{{ field }} è obbligatorio',
        checkbox_required: 'Questo campo è obbligatorio',
        error_header: 'Correggi il seguente errore'
      }
    };
  }

  t(key, replacements) {
    const locale = (typeof Shopify !== 'undefined' && Shopify.locale === 'it') ? 'it' : 'en';
    let message = this.translations[locale][key] || this.translations['en'][key] || key;
    if (replacements) {
      for (const [placeholder, value] of Object.entries(replacements)) {
        message = message.replace('{{ ' + placeholder + ' }}', value);
      }
    }
    return message;
  }

  updateFormValidityStatus(form) {

    let fields = form.querySelectorAll('.form--error');
    if (fields.length > 0) {
      form.classList.add('form--invalid');
    } else {
      form.classList.remove('form--invalid');
    }
  }

  setElementValidation(el, message) {

    let field = el.closest('.field');
    if (!field) {
      field = el.closest('.checkbox-field');
    }

    if (message) {
      el.classList.add('invalid');

      if (field) {
        field.classList.add('form--error');
      }
    } else {
      el.classList.remove('invalid');
      if (field) {
        field.classList.remove('form--error');
      }
    }
  }

  getPasswordValidationMessage(password) {

    var isBlank = password.length === 0;
    if(isBlank) {
      return this.t('password_blank');
    }

    var lowerCaseLetters = /[a-z]/g;
    if(!password.match(lowerCaseLetters)) {
      return this.t('password_lowercase');
    }

    // Validate capital letters
    var upperCaseLetters = /[A-Z]/g;
    if(!password.match(upperCaseLetters)) {
      return this.t('password_uppercase');
    }

    // Validate numbers
    var numbers = /[0-9]/g;
    if(!password.match(numbers)) {
      return this.t('password_number');
    }

    // Validate special characters
    var specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
    if(!password.match(specialCharacters)) {
      return this.t('password_special');
    }

    // Validate length
    if(password.length < 8) {
      return this.t('password_length');
    }

    return false;
  }

  keyup(el) {
    let message = false;
    let form = el.form;
    let fieldTitle = document.querySelector('[for="'+el.id+'"]'); 

    if (el.type === 'password') {
      if (el.classList.contains('confirm-password')) {
        let passwordEl = form.querySelector('[type=password]');
        if (passwordEl.value !== el.value) {
          message = this.t('passwords_no_match');
        }
      } else {
        if (el.dataset.validate === 'blank') {
          if (el.value.length === 0) {
            message = this.t('password_blank');
          }
        } else {
          message = this.getPasswordValidationMessage(el.value);
        }

        if (message) {
          this.setElementValidation(el, message);
        }

        let confirmPasswordEl = form.querySelector('.confirm-password');
        if (confirmPasswordEl) {
          if (confirmPasswordEl.value.length > 0) {
            if (confirmPasswordEl.value !== el.value) {
              this.setElementValidation(confirmPasswordEl, this.t('passwords_no_match'));
            } else {
              this.setElementValidation(confirmPasswordEl, false);
            }
          }
        }
      }
    } else if (el.type === 'email') {
      if (el.required) {
        // check if blank
        if (el.value.length === 0) {
          message = this.t('email_required');
        }
      }
      // check if valid email
      var email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!el.value.match(email)) {
        message = this.t('email_invalid');
      }
    } else if (el.type === 'text' || el.type === 'checkbox' || el.type === 'tel' ) {

      if (el.required) {
        // check if blank
        if (el.type === 'checkbox') {
          if (el.checked !== true) {
            message = this.t('checkbox_required');
          }
        } else if (el.value.length === 0) {

          let fieldTitleText = '';
          if (fieldTitle) {
            fieldTitle.classList.add('form-field--invalid');
            fieldTitleText = fieldTitle.innerText.toLowerCase().replace('*', '').trim();
            // Capitalize
            fieldTitleText = fieldTitleText.charAt(0).toUpperCase() + fieldTitleText.slice(1);
          } 
          message = this.t('field_required', { field: fieldTitleText });

        } else {
          if (fieldTitle) {
            fieldTitle.classList.remove('form-field--invalid');
          }
        }
      }
    } else if (el.type === 'select-one') {
      if (el.required) {

        // check if blank
        if (el.value.length === 0 || el.value == "---" ) {

          let fieldTitleText = '';
          if (fieldTitle) {
            fieldTitle.classList.add('form-field--invalid');
            fieldTitleText = fieldTitle.innerText.toLowerCase().replace('*', '').trim();
            // Capitalize
            fieldTitleText = fieldTitleText.charAt(0).toUpperCase() + fieldTitleText.slice(1);
          } 
          message = this.t('field_required', { field: fieldTitleText });

        } else {
          if (fieldTitle) {
            fieldTitle.classList.remove('form-field--invalid');
          }
        }
      }
    }

    this.createErrorMessageHTML(el,message);
    this.setElementValidation(el, message);
    this.updateFormValidityStatus(form);

    return message;
  }

  createErrorMessageHTML(el,message) {
    let existingErrorEl = el.form.querySelector('.errors');
    if (existingErrorEl) {
      existingErrorEl.remove();
    }

    if (message.length > 0) {
      let html = `<div class="errors"><p>${this.t('error_header')}</p><ul><li>${message}</li></ul></div>`;
      el.form.insertAdjacentHTML('beforeend', html);
    }
  }


  submit(el) {
    let form = el.closest('form');
 
    let fields = form.querySelectorAll('input[type="text"],input[type="tel"],input[type="password"],input[type="email"],input[type="checkbox"],select');

    for (let i = 0; i < fields.length; i++) {

      // Show the first error only
      let field = fields[i];
      if( this.keyup(field) ) {
        return false;
      }
    }

    this.updateFormValidityStatus(form);

  }
}

const fostrFormValidation = new FostrFormValidation();